import { fetchConfigLogada } from "@/app/api/configuracoes/config/fetch";
import { useCurrentUser } from "@/hooks/use-current-user";
import {
  ReactNode,
  createContext,
  useContext,
  useEffect,
  useState,
} from "react";
import { ConfigLogada } from "../types/config/config";

interface ConfigContextProps {
  config: ConfigLogada | null;
  setConfig: (config: ConfigLogada) => void;
  reloadConfig: () => void;
}

const ConfigContext = createContext<ConfigContextProps | undefined>(undefined);

export const ConfigProvider = ({ children }: { children: ReactNode }) => {
  const user = useCurrentUser();
  const [config, setConfig] = useState<ConfigLogada | null>(null);

  const reloadConfig = async () => {
    if (user?.id && user?.contratanteId) {
      const fetchedConfig = await fetchConfigLogada(
        user.id,
        user.contratanteId,
      );
      setConfig(fetchedConfig);
    }
  };

  useEffect(() => {
    reloadConfig();
  }, [user?.id]);

  return (
    <ConfigContext.Provider value={{ config, setConfig, reloadConfig }}>
      {children}
    </ConfigContext.Provider>
  );
};

export const useConfig = () => {
  const context = useContext(ConfigContext);
  if (context === undefined) {
    throw new Error("Configuração deve ser usado dentro de um ConfigProvider");
  }
  return context;
};
